import { render, staticRenderFns } from "./CommentActionMenu.vue?vue&type=template&id=9bd041d8&scoped=true"
import script from "./CommentActionMenu.vue?vue&type=script&lang=js"
export * from "./CommentActionMenu.vue?vue&type=script&lang=js"
import style0 from "./CommentActionMenu.vue?vue&type=style&index=0&id=9bd041d8&prod&lang=scss&scoped=true"
import style1 from "./CommentActionMenu.vue?vue&type=style&index=1&id=9bd041d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd041d8",
  null
  
)

export default component.exports